// Entry point for site JS, import all other scripts.

// Polyfills
import './polyfills/_ObjectValuesPolyfill';
import './polyfills/_MathPolyfill';
import './polyfills/_ArrayFromPolyfill';
import './polyfills/_ElementFunctionsPolyfill';
import './polyfills/_ScopePseudoSelectorPolyfill';
import './polyfills/_DocumentFragmentFunctionsPolyfill';
import './polyfills/_NodeListForEachPolyfill';
import './polyfills/_ClassListPolyfill';
import './polyfills/_EventObjectPolyfill';
import './polyfills/_StringRepeatPolyfill';
import './polyfills/_PromisePolyfill';
import './polyfills/_FetchPolyfill';
import './polyfills/_TemplatePolyfill';
import './polyfills/_ResizeObserverPolyfill';
import './polyfills/_IntersectionObserverPolyfill';
import './polyfills/_URLPolyfill';
import './polyfills/_URLSearchParamsPolyfill';
import './polyfills/_FocusVisible';
import './polyfills/_ClosestPolyfill';
import './polyfills/_ArrayIncludesPolyfill';

// Libraries
import './lib/lazysizes.bgset';
import './lib/lazysizes';

// Components
import '../components/Button/_Button';
import '../components/DecoratedBannerBox/_DecoratedBannerBox';
import '../components/HeaderMenu/_HeaderMenu';
import '../components/HeaderNavigation/_HeaderNavigation';
import '../components/JuicerFeed/_JuicerFeed';
import '../components/ImageMosaic/_ImageMosaic';
import '../components/Text/_Text';
import '../components/Image/_Image';
import '../components/BoatTitleLockup/_BoatTitleLockup';
import '../components/SocialIcon/_SocialIcon';
import '../components/Footer/_Footer';
import '../components/BoatCard/_BoatCard';
import '../components/BoatSpecsPanel/_BoatSpecsPanel';
import '../components/ScheduleDemoCta/_ScheduleDemoCta';
import '../components/FooterNewsletterForm/_FooterNewsletterForm';
import '../components/PageHomepage/_PageHomepage';
import '../components/LayoutOneColumn/_LayoutOneColumn';
import '../components/LayoutOneColumnHeader/_LayoutOneColumnHeader';
import '../components/BlockCards/_BlockCards';
import '../components/HomepageBanner/_HomepageBanner';
import '../components/HomepageSlide/_HomepageSlide';
import '../components/CardRouter/_CardRouter';
import '../components/Carousel/_Carousel';
import '../components/PageDealers/_PageDealers';
import '../components/BoatSpecs/_BoatSpecs';
import '../components/TitleWithButton/_TitleWithButton';
import '../components/FeatureCard/_FeatureCard';
import '../components/BoatPhotosAndSpecs/_BoatPhotosAndSpecs';
import '../components/BoatPhotos/_BoatPhotos';
import '../components/PageBoat/_PageBoat';
import '../components/BoatFeatures/_BoatFeatures';
import '../components/VideoPlayerWithList/_VideoPlayerWithList';
import '../components/HeaderBoatCard/_HeaderBoatCard';
import '../components/BoatSpecialEditions/_BoatSpecialEditions';
import '../components/BoatDesignYours/_BoatDesignYours';
import '../components/BoatBanner/_BoatBanner';
import '../components/ImageAndText/_ImageAndText';
import '../components/PagePage/_PagePage';
import '../components/Svg/_Svg';
import '../components/PageFeatures/_PageFeatures';
import '../components/BlockMosaic/_BlockMosaic';
import '../components/PageBoatPhotos/_PageBoatPhotos';
import '../components/BackgroundImage/_BackgroundImage';
import '../components/PageTv/_PageTv';
import '../components/LayoutSidebar/_LayoutSidebar';
import '../components/Sidebar/_Sidebar';
import '../components/EventCard/_EventCard';
import '../components/DownloadCard/_DownloadCard';
import '../components/FeatureMinorCard/_FeatureMinorCard';
import '../components/PressCard/_PressCard';
import '../components/ReviewCard/_ReviewCard';
import '../components/PageBoatFeatures/_PageBoatFeatures';
import '../components/PageBoatReviews/_PageBoatReviews';
import '../components/PageBoatPress/_PageBoatPress';
import '../components/Pagination/_Pagination';
import '../components/PageBoatSpecs/_PageBoatSpecs';
import '../components/FilterSelect/_FilterSelect';
import '../components/PageEvents/_PageEvents';
import '../components/PageReviews/_PageReviews';
import '../components/PagePress/_PagePress';
import '../components/PageEvent/_PageEvent';
import '../components/PageBoatVideos/_PageBoatVideos';
import '../components/PageBoatWarranty/_PageBoatWarranty';
import '../components/PageBoatTutorials/_PageBoatTutorials';
import '../components/Form/_Form';
import '../components/FormHiddenInput/_FormHiddenInput';
import '../components/FormInput/_FormInput';
import '../components/FormLabel/_FormLabel';
import '../components/FormSelect/_FormSelect';
import '../components/FormSubmit/_FormSubmit';
import '../components/FormTextarea/_FormTextarea';
import '../components/SearchCard/_SearchCard';
import '../components/BlockBigCarouselSlide/_BlockBigCarouselSlide';
import '../components/BaseCarousel/_BaseCarousel';
import '../components/BaseVideo/_BaseVideo';
import '../components/BlockVideo/_BlockVideo';
import '../components/BlockPopup/_BlockPopup';
import '../components/PageCompareBoats/_PageCompareBoats';
import '../components/PageAtxUniversity/_PageAtxUniversity';
import '../components/LayoutAtxUSidebar/_LayoutAtxUSidebar';
import '../components/SidebarAtxU/_SidebarAtxU';
import '../components/AtxUCard/_AtxUCard';
import '../components/AimbaseForms/_AimbaseForms';
import '../components/BlockMasonry/_BlockMasonry';
import '../components/BlockMediaBanner/_BlockMediaBanner';
import '../components/BlockTextCarouselWithSwappingImage/_BlockTextCarouselWithSwappingImage';
import '../components/BlockVirtualExperience/_BlockVirtualExperience';
// AUTO-INJECT-HERE - Don't edit or touch this comment unless you know what you're doing.

import Component from './_Component'; // Get component initialization functions.
import SVGResizeFixForIE from './util/_SVGResizeFixForIE'; // Manually resize marked SVGs that have broken scaling in IE.
import GridObserver from './util/_GridObserver'; // Manage grid classes.
import ExternalLinkProcessor from './util/_ExternalLinkProcessor'; // Adds attributes to external links.
import IS_IE from './util/_IEBrowserClass'; // Add `ie` class to root for IE.
import ScrollEnforcer from './util/_ScrollEnforcer'; // Try to prevent horizontal slack.
import AnimationApplier from './util/_AnimationApplier'; // Add classes to visible, animatable elements.


function init() {
	ScrollEnforcer.preventHorizontal(document.body);

	SVGResizeFixForIE.attach();

	// Initialize all components on existing page and then monitor for changes.
	Component.scan(document.body);
	Component.monitor(document.body);

	// Initialize grid by looking for all row elements on the page.
	GridObserver.scan(document.body);
	GridObserver.monitor(document.body);

	// Watch animatable components for intersection.
	AnimationApplier.scan(document.body);
	AnimationApplier.monitor(document.body);

	/** Processes all external links (add attributes). */
	function processExternalLinks() {
		// Get the list of pseudo external links from the meta tag (populated from a global field)
		const meta: HTMLMetaElement = document.querySelector('meta[name="pseudo-external-links"]');

		if (!meta) {
			return;
		}

		// Format the array and pass it in to the processor as a list of links to treat as external
		const pseudoExternalLinks: string[] = meta.content.split(',');
		const externalLinkProcessor = new ExternalLinkProcessor(pseudoExternalLinks);

		// Scan the document for links immediately whenever a mutation occurs
		externalLinkProcessor.scan(document.body);
		externalLinkProcessor.monitor(document.body);
	}

	processExternalLinks();

	document.body.classList.remove('content-loading');
}

if (IS_IE) {
	// Wait for a repaint to initialize in order to allow polyfill overrides to be available in IE.
	requestAnimationFrame(init);
} else {
	// Initialize ASAP.
	init();
}
